import { FC } from 'react'

import { Card, CardContent, Cluster, Grid, Separator, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'

const BookingHeaderSkeleton: FC = () => {
  return (
    <Cluster gap={8} x="between" y="center">
      <Cluster gap={16} y="center" breakpoint="sm">
        <Cluster gap={8} y="center">
          <Skeleton variant="icon" />
          <Stack gap={4}>
            <Skeleton variant="badge" />
            <Skeleton variant="content" size={2} />
          </Stack>
        </Cluster>
        <Separator orientation="vertical" />
        <Skeleton variant="button" />
        <Skeleton variant="button" />
        <Skeleton variant="button" />
        <Skeleton variant="button" />
        <Skeleton variant="icon" />
      </Cluster>
      <Cluster gap={8} y="center">
        <Skeleton variant="avatar" />
        <Skeleton variant="avatar" />
        <Skeleton variant="avatar" />
        <Skeleton variant="avatar" />
        <Skeleton variant="icon" />
      </Cluster>
    </Cluster>
  )
}

const BookingSidebarSkeleton: FC = () => {
  return (
    <Stack gap={16}>
      <Card>
        <CardContent>
          <Stack gap={4}>
            <Skeleton variant="badge" />
            <Skeleton variant="content" size={2} />
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Stack gap={8}>
            <Skeleton variant="badge" />
            <Skeleton variant="content" fullWidth />
            <Skeleton variant="content" size={16} fullWidth />
            <Skeleton variant="content" size={16} fullWidth />
            <Skeleton variant="badge" />
            <Skeleton variant="content" fullWidth />
            <Skeleton variant="content" size={16} fullWidth />
            <Skeleton variant="content" size={16} fullWidth />
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  )
}

const BookingMainSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      <Card>
        <CardContent>
          <Stack gap={16}>
            <Skeleton variant="badge" />
            <Skeleton variant="content" size={16} fullWidth />
            <Cluster gap={8}>
              <Skeleton variant="badge" />
              <Skeleton variant="badge" />
              <Skeleton variant="badge" />
              <Skeleton variant="badge" />
              <Skeleton variant="badge" />
            </Cluster>
          </Stack>
        </CardContent>
      </Card>
      <Cluster gap={16} fullWidth>
        <Skeleton variant="icon" />
        <Stack gap={8} fullWidth>
          <Grid col={2}>
            <Skeleton variant="badge" fullWidth />
          </Grid>
          <Grid col={4}>
            <Skeleton variant="content" fullWidth />
          </Grid>
          <Stack />
          <Card>
            <CardContent>
              <Stack gap={24}>
                <Stack gap={8}>
                  <Skeleton variant="content" fullWidth />
                  <Grid col={2}>
                    <Skeleton variant="content" fullWidth />
                  </Grid>
                </Stack>
                <Stack gap={12}>
                  <Grid col={2}>
                    <Skeleton variant="badge" fullWidth />
                  </Grid>
                  <Skeleton variant="content" fullWidth size={16} />
                  <Skeleton variant="button" />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Cluster>
      <Cluster gap={16} fullWidth>
        <Skeleton variant="icon" />
        <Stack gap={8} fullWidth>
          <Grid col={2}>
            <Skeleton variant="badge" fullWidth />
          </Grid>
          <Grid col={4}>
            <Skeleton variant="content" fullWidth />
          </Grid>
          <Stack />
          <Card>
            <CardContent>
              <Stack gap={24}>
                <Cluster gap={8} fullWidth>
                  <Skeleton variant="avatar" />
                  <Stack gap={8} fullWidth>
                    <Skeleton variant="content" fullWidth />
                    <Skeleton variant="content" fullWidth />
                    <Grid col={2}>
                      <Skeleton variant="content" fullWidth />
                    </Grid>
                  </Stack>
                </Cluster>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Cluster>
    </Stack>
  )
}

const BookingContextSkeleton: FC = () => {
  return (
    <Stack gap={12}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Stack key={index}>
          <Cluster gap={8} fullWidth>
            <Skeleton variant="icon" />
            <Skeleton variant="button" fullWidth />
          </Cluster>
          <Separator orientation="horizontal" />
        </Stack>
      ))}
    </Stack>
  )
}

export const BookingSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<BookingHeaderSkeleton />}
      navigation={<Back to="/" search />}
      main={<BookingMainSkeleton />}
      footer={<Footer />}
      sidebar={<BookingSidebarSkeleton />}
      context={<BookingContextSkeleton />}
    />
  )
}
